import { i18n } from '@/locales';
import { attendCode } from '.';
const lc = 'views.worker_management.';
const listLc = 'views.worker_management_list.';
/**
 * 테이블 작업 컨벤션
 * 1. table width의 경우 한개의 셀을 정해서 flexible 셀로 활용 한다. (width를 지정하지 않으면 된다.)
 * 1-1. flexible 셀을 지정하는 이유: https://www.notion.so/barogohq/2c2a129c88434ffe8bcb2ea525470cef?p=48a52b69202e4cd1acbbce04dd9343e2&pm=s
 * 2. td의 width는 아래 셋팅값에서 일괄 설정 한다. width 설정이 분산 되지 않도록 유의 한다.
 * 3. td의 css class는 td 템플릿 파일에서 지정 한다.
 * 3-1. 참조: src/views/WorkerManagement/WorkerList/WorkerListRow.vue
 * 4. td의 width를 제외한 css 핸들링은 td의 상위 레벨인 table 컴포넌트에서 지정한다. (td에서 하면 중복 출력 됨)
 * 4-1. 참조: src/views/WorkerManagement/WorkerList/WorkerListTable.vue
 */
/**
 * 관리페이지 헤더정렬 정의 문서: https://www.notion.so/barogohq/408e2c6747604c0d842bf7aad89c55d8
 */
export const workerListTableHeader = [
    {
        title: i18n.t(`${listLc}status`),
        align: 'center',
        sortable: true,
        value: 'useYn',
        width: 74,
    },
    {
        title: i18n.t(`${listLc}worker_name`),
        align: 'start',
        sortable: true,
        value: 'name',
        width: 144,
    },
    {
        title: i18n.t('common.type'),
        align: 'start',
        sortable: true,
        value: 'type',
        width: 132,
    },
    {
        title: i18n.t(`${listLc}attend_code`),
        align: 'center',
        sortable: true,
        value: 'attendCode',
        width: 95,
    },
    {
        title: i18n.t(`${lc}work_time`),
        align: 'start',
        sortable: false,
        value: 'workTime',
        width: 120,
    },
    {
        title: i18n.t(`${listLc}phone`),
        align: 'start',
        sortable: true,
        value: 'phone',
        width: 134,
    },
    {
        title: i18n.t(`${listLc}car_number`),
        align: 'start',
        sortable: false,
        value: 'carNumber',
        width: 134,
    },
    {
        title: i18n.t(`${listLc}name_of_belong_hub`),
        align: 'start',
        sortable: true,
        value: 'hubId',
        width: 182,
    },
    {
        title: i18n.t(`${listLc}hub_employee_number`),
        align: 'center',
        sortable: true,
        value: 'hubEmployeeNumber',
        width: 154,
    },
    {
        title: i18n.t(`${lc}worker_employee_type`),
        align: 'center',
        sortable: true,
        value: 'employeeType',
        width: 146,
    },
    {
        title: i18n.t(`${lc}salary_type`),
        align: 'center',
        sortable: true,
        value: 'salaryType',
        width: 150,
    },
    {
        title: i18n.t(`${lc}insurance_deposit`),
        align: 'end',
        sortable: false,
        value: 'totalInsuranceDepositBaromoney',
        width: 170,
    },
    {
        title: i18n.t(`${lc}deposit_set_by_hub`),
        align: 'end',
        sortable: true,
        value: 'depositBaromoney',
        width: 170,
    },
    {
        title: i18n.t(`${lc}baromoney`),
        align: 'end',
        sortable: true,
        value: 'baromoney',
        width: 170,
    },
    {
        title: i18n.t(`${lc}conviction_status`),
        align: 'center',
        sortable: true,
        value: 'convictionStatus',
        width: 170,
    },
    {
        title: i18n.t(`${lc}worker_reg_date`),
        align: 'center',
        sortable: true,
        value: 'workerRegDate',
        width: 120,
    },
];
// 라이더목록 ENUM관련 문서 : https://www.notion.so/barogohq/142de9a1de98498aafa98b1efc974b7d
export const searchFieldTypeOptions = [
    {
        text: i18n.t(`${listLc}worker_name`),
        value: 'NAME',
        field: 'name',
    },
    {
        text: i18n.t(`${listLc}hub_employee_number`),
        value: 'HUB_EMPLOYEE_NUMBER',
        field: 'hubEmployeeNumber',
    },
    {
        text: i18n.t(`${listLc}phone`),
        value: 'PHONE',
        field: 'phone',
    },
    {
        text: i18n.t(`${listLc}car_number`),
        value: 'CAR_NUMBER',
        field: 'carNumber',
    },
];
export const workerStatusOptions = [
    {
        text: i18n.t('common.all'),
        value: 'ALL',
        field: 'useYn',
        imgIcon: '',
    },
    {
        text: i18n.t(`${listLc}ok`),
        value: 'OK',
        field: 'useYn',
        imgIcon: 'ok',
    },
    {
        text: i18n.t(`${listLc}stop`),
        value: 'STOP',
        field: 'useYn',
        imgIcon: 'stop',
    },
    {
        text: i18n.t(`${listLc}leave`),
        value: 'LEAVE',
        field: 'useYn',
        imgIcon: 'leave',
    },
    // 삭제(DELETE)의 경우 데이터 구분용으로 사용중이며 imgIcon의 경우 존재하지 않음.
    {
        text: i18n.t(`${listLc}delete`),
        value: 'DELETE',
        field: 'useYn',
        imgIcon: 'delete',
    },
];
export const typeOptions = [
    {
        text: i18n.t('common.all'),
        value: 'ALL',
        field: 'type',
    },
    {
        text: i18n.t(`${listLc}normal_worker`),
        value: 'NORMAL_WORKER',
        field: 'type',
    },
    {
        text: i18n.t(`${listLc}black_worker_5`),
        value: 'BLACK_WORKER_5KM',
        field: 'type',
    },
    {
        text: i18n.t(`${listLc}black_worker_10`),
        value: 'BLACK_WORKER_10KM',
        field: 'type',
    },
];
export const workerStatusTypeData = {
    // 전체
    ALL: {
        text: i18n.t('common.all'),
        value: 'ALL',
    },
    // 정상
    OK: {
        text: i18n.t(`${listLc}ok`),
        value: 'OK',
    },
    // 정지
    STOP: {
        text: i18n.t(`${listLc}stop`),
        value: 'STOP',
    },
    // 퇴직
    LEAVE: {
        text: i18n.t(`${listLc}leave`),
        value: 'LEAVE',
    },
};
export const typeData = {
    // 전체
    ALL: {
        text: i18n.t('common.all'),
        value: 'ALL',
    },
    // 일반
    NORMAL_WORKER: {
        text: i18n.t(`${listLc}normal_worker`),
        value: 'NORMAL_WORKER',
    },
    // 위치기반 (5Km)
    BLACK_WORKER_5KM: {
        text: i18n.t(`${listLc}black_worker_5`),
        value: 'BLACK_WORKER_5KM',
    },
    // 위치기반 (10Km)
    BLACK_WORKER_10KM: {
        text: i18n.t(`${listLc}black_worker_10`),
        value: 'BLACK_WORKER_10KM',
    },
};
export const salaryTypeOptions = [
    {
        // 전체
        text: i18n.t('common.all'),
        value: 'ALL',
        field: 'salaryType',
    },
    {
        // 고정급 (출금제한)
        text: i18n.t(`${listLc}fixed_pay`),
        value: 'FIXED_PAY',
        field: 'salaryType',
    },
    {
        // 실적급 (자율출금)
        text: i18n.t(`${listLc}performance_pay`),
        value: 'PERFORMANCE_PAY',
        field: 'salaryType',
    },
];
export const salaryTypeData = {
    // 전체
    ALL: {
        text: i18n.t('common.all'),
        value: 'ALL',
        field: 'ALL',
    },
    // 고정급 (출금제한)
    FIXED_PAY: {
        text: i18n.t(`${listLc}fixed_pay`),
        value: 'FIXED_PAY',
        field: 'FIXED_PAY',
    },
    // 실적급 (자율출금)
    PERFORMANCE_PAY: {
        text: i18n.t(`${listLc}performance_pay`),
        value: 'PERFORMANCE_PAY',
        field: 'PERFORMANCE_PAY',
    },
};
/**
 * 상단 라이더 상태
 * @param workerDetail
 * @returns
 */
export const getWorkerStatusContent = (workerDetail) => {
    if (!workerDetail) {
        return null;
    }
    return [
        {
            text: '운행상태',
            value: i18n.t(attendCode[workerDetail.attendCode].text),
            textColor: 'green darken-4',
            color: 'green lighten-4',
        },
        {
            text: '현재 배차 건',
            value: i18n.t('common.count_suffix', {
                count: workerDetail.nowAllocatedCount,
            }),
            textColor: 'blue darken-4',
            color: 'blue lighten-4',
        },
        {
            text: '현재 픽업 건',
            value: i18n.t('common.count_suffix', {
                count: workerDetail.nowPickupCount,
            }),
            textColor: 'brown darken-4',
            color: 'brown lighten-4',
        },
    ];
};
